import firebase from "firebase/app";

import { Button, Card, Message } from "semantic-ui-react";

import { useCallback } from "react";
import { useTranslation } from "react-i18next";

import Flex from "astrid-components/lib/components/Layout/Flex";
import updateDocument from "astrid-firestore/src/helpers/updateDocument";
import { getUserRef } from "astrid-firestore/src/utils/referenceMappers";

import { useProfile } from "../../../../authentication/state/profile";
import useHasRight from "../../../../authorization/hooks/useHasRight";

import DeleteOrderAction from "./DeleteOrderAction";

export default function OrderActions({ order, invoices }) {
	const { t } = useTranslation();
	const hasRight = useHasRight();
	const user = useProfile();

	const onClickDone = useCallback(() => {
		if (!order.processed || window.confirm(t("sureSetUnprocessed"))) {
			updateDocument(order.ref, {
				processed: !order.processed,
				processedBy: getUserRef(user),
				processedAt: firebase.firestore.FieldValue.serverTimestamp(),
			});
		}
	}, [order.processed, order.ref, t, user]);

	if (order.deleted) {
		return false;
	}

	if (order.inactivated) {
		return (
			<Card fluid>
				<Card.Content>
					<Message
						info
						content={`${t(
							"salesOrderInactivated",
							"This sales order was inactivated:",
						)} ${order?.inactivatedBy?.time?.toDate?.()?.toLocaleString()}`}
					/>
				</Card.Content>
			</Card>
		);
	}

	return (
		<Card fluid>
			{hasRight("orders.manage") && (
				<Card.Content>
					<Flex justifyContent="flex-start" gap={10}>
						<Button color={order.processed ? "grey" : "teal"} onClick={onClickDone}>
							{t("toggleProcessed", { status: order.processed ? t("unprocessed") : t("processed") })}
						</Button>

						{order.processed && (
							<>
								Processed {order.processedAt?.toDate().toLocaleString()} by {order.processedBy?.name}
							</>
						)}

						<DeleteOrderAction order={order} invoices={invoices} />
					</Flex>
				</Card.Content>
			)}
		</Card>
	);
}
